export default class NotFoundError extends Error {
  notFoundError = true
  resourceType: string

  constructor(resourceType: string, ...args) {
    // @ts-expect-error Error constructor args spread
    super(`Resource ${resourceType} not found.`, ...args)
    this.resourceType = resourceType
  }
}
